import React from 'react';
import { fontFamily, colour, ActionButton, Input } from './GlobalStyles';
import { useSelector, useDispatch } from 'react-redux';
import { addressAction } from './actions';
import './MobileBookPage.css';

const AddressMobile = React.forwardRef((props, ref) => {

    const currentAddress = useSelector(state => state.addressAction);
    const dispatch = useDispatch();

    const styles = {
        headerText: {
            fontFamily: fontFamily,
            color: colour.dark,
            fontWeight: 'normal',
            fontSize: '1.375em',
            textAlign: 'center'
        },
        back: {
            fontFamily: fontFamily,
            color: colour.dark,
            fontSize: '0.875em',
            fontWeight: 'normal',
            textAlign: 'center',
            cursor: 'pointer'
        }
    }

    return (
        <div className="mobileBookPageOuterContainer">
            <h1 style={styles.headerText}>
                Inserisci il tuo indirizzo di casa
            </h1>
            <div>
                <Input
                    value={currentAddress}
                    id="outlined"
                    label="Indirizzo"
                    inputProps={{
                        autoCapitalize: 'none',
                    }}
                    variant="outlined"
                    onChange={(text) => dispatch(addressAction(text.target.value))}
                />
                <div style={{ height: '2vh' }} />
                <ActionButton
                    ref={ref} {...props}
                    disabled={
                                currentAddress === "" ?
                                true
                                :
                                false
                            }
                >
                    Continua
                </ActionButton>
                <div style={{ height: '2vh' }} />
                <p
                    onClick={() => props.onBack()} 
                    style={styles.back}
                >
                    Indietro
                </p>
            </div>
        </div>
    )
})

export default AddressMobile;